// Stats
export const statTarget = '[data-stat-target]';

// Latest news callout
export const latestNewsCalloutTarget = '[data-latest-news-callout-slider]';

// Video controls
export const videoWithControlsTarget = '[data-video-with-controls]';
export const videoEmbedWithControlsTarget = '[data-video-embed-with-controls]';

// In view components
export const inViewVideoTarget = '[data-inview-video]';

//modal
export const modalContainerTarget = '[data-modal-container]';

//announcement strip
export const announcementStrip = '[data-announcement-strip-target]';
export const announcementStripClose = '[data-announcement-strip-close]';

// image hero
export const imageHeroSlider = '[data-image-hero-slider]';

// header
export const headerTarget = '[data-header]';

//accordion
export const accordionsContainerTarget = '[data-accordion-container-target]';

// text/image carousel
export const textImageCarouselSwiperTargetLeft =
	'[data-text-image-carousel-swiper-left]';
export const textImageCarouselSwiperTargetRight =
	'[data-text-image-carousel-swiper-right]';

// team carousel
export const teamCarouselSwiperTarget = '[data-team-carousel-swiper]';

//listing pagination
export const dataPostListingTarget = '[data-post-listing-target]';
export const dataPaginationContainer = '[data-pagination-container]';
export const dataPrevBtn = '[data-prev-btn]';
export const dataNextBtn = '[data-next-btn]';
export const dataPost = '[data-post]';

//search
export const dataSearchResultList = '[data-search-result-list]';

//Tabs
export const tabTarget = '[data-tab-list]';
export const tabTargetItem = '[data-tab-target]';
export const paginationTarget = '[data-pagination]';



// WEBPACK FOOTER //
// ./scripts/components/index.ts